import React, {Component} from 'react';
import {Table} from 'react-data-components';
import EditDiagnosticTestContainer from '../../../containers/AdminPanel/EditDiagnosticTestContainer';
import {connect} from 'react-redux';
import { ACTION_AUTH_PASSWORD_RESET_COMPLETED } from '../../../store/actions/authActions';
import * as chapterPartActions from '../../../store/actions/chapterPartActions';

const questionTemplate = {
    question: '',
    optionA: '',
    optionB: '',
    optionC: '',
    optionD: '',
    correctOption: '',
    concept: ''
}

const courses = [
    {
        course: 'MCAT',
        subject: 'Maths',
        title: 'Angelfish piranha alas hey much b',
        options: 'options',
        id: '000010'
    },
    {
        course: 'LSAT',
        subject: 'Physics',
        title: 'Justly away shaky re-laid including therefore m',
        options: 'options',
        id: '000020'
    },
    {
        course: 'GMAT',
        subject: 'Maths',
        title: 'Shrank less unlocked messy without bird hellish',
        options: 'options',
        id: '000030'
    },
    {
        course: 'GMAT',
        subject: 'Physics',
        title: 'Debating me breeding be answered an',
        options: 'options',
        id: '000040'
    },
    {
        course: 'MCAT',
        subject: 'Chemistry',
        title: 'His followed carriage proposal entrance',
        options: 'options',
        id: '000050'
    },
    {
        course: 'MCAT',
        subject: 'Chemistry',
        title: 'Literature admiration frequently indulgence',
        options: 'options',
        id: '000060'
    },
    {
        course: 'MCAT',
        subject: 'Physics',
        title: 'Mandrill insufferable ouc',
        options: 'options',
        id: '000070'
    },
    {
        course: 'GMAT',
        subject: 'Chemistry',
        title: 'More preparatory much derisively far impul',
        options: 'options',
        id: '000080'
    },
    {
        course: 'LSAT',
        subject: 'Chemistry',
        title: 'More preparatory much derisively fa',
        options: 'options',
        id: '000090'
    }
];

const questions = [
    {
        id: '0020201',
        title: 'Question',
        number: 1,
        description: '',
        removeQuestion: false,
        checkedOption: 'C',
        optionA: '',
        optionB: '',
        optionC: '',
        optionD: ''
    }
];

const testTemplate = {
    title: '',
    show_description: '',
    instructions: '',
    course: '',
    subject: '',
    sections: [
        {name: '', questions: [], subjectId: ''}
    ]
}

class StrategyModalDiagnosticTest extends Component {
    state = {
        columns: [],
        activeCourse: {},
        activeSection: 0,
        viewMode: 'add',
        waitingForTestCreation: false,
        testTemplate: '',
        test: {
            title: '',
            show_description: '',

            instructions: '',
            course: '',
            courseId: '',
            subject: '',
            sections: [
                {name: '', subjectId: '', questions: []}
            ]
        },
        currentTab: 0
    };

    //Renders
    renderOptions = (val, row) => {
        return (
            <div className="dropdown">
                <a href="#"
                   data-toggle="dropdown"
                   className="btn btn-default"
                >
                    Options
                </a>
                <ul className="dropdown-menu pull-right">
                    <li>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            this.props.setTest(row);
                        }}>
                            <i className="zmdi zmdi-plus-circle"/> Set as Courses Test
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            let test = JSON.parse(JSON.stringify(row));
                            delete test.id;
                            test.title = test.title + " (copy)";
                            this.props.saveTest(test, this.props.user.id);
                        }}>
                            <i className="zmdi zmdi-copy"

                            /> Copy Test
                        </a>
                    </li>
                    <li>
                        <a href="#"  onClick={(e) => {
                            e.preventDefault();
                            this.setState({test: JSON.parse(JSON.stringify(row)), 
                            diagnosticTestId: row.id, viewMode: 'edit', activeCourse: this.props.courses.filter(c => c.id == JSON.parse(JSON.stringify(row)).courseId)[0], currentTab: 1});
                        }}>
                            <i className="zmdi zmdi-edit"
                            /> Edit Test
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            this.setState({test: testTemplate, currentTab: 1});
                        }}>
                            <i className="zmdi zmdi-plus-circle"/> Add Test
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => {
                            this.props.deleteTest(row.id, this.props.user.id);
                        }}>
                            <i className="zmdi zmdi-delete" /> Delete
                        </a>
                    </li>
                </ul>
            </div>
        )
    }
    
    renderTestCreation = () => {
        return (
            <div>
                Select Test Template?
                <div className="row">
                    <div className="col-md-12">
                        <select className="form-control" value={this.state.testTemplate}
                        onChange={e => this.setState({testTemplate: e.target.value})}>
                            <option>Select Test Template</option>
                            {this.state.activeCourse ?
                                this.state.activeCourse.ChapterTestTemplate ?
                                this.state.activeCourse.ChapterTestTemplate.map(t => {
                                    return (
                                        <option value={t.id}>{t.title || t.name}</option>
                                    )
                                })
                                
                                : null
                            
                                : null
                            }
                        </select>
                    </div>
                </div>
            </div>
        )
    }
    
    renderTestEditOld = () => {
        return (
            <div className="form-group">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Course</label>
                                                        <select disabled={true} className="form-control"
                                                            value={this.state.test.courseId}
                                                                onChange={(e) => {
                                                                    let course = this.props.courses.filter(course => course.id === e.target.value)[0];
                                                                    if(course) {
                                                                        let {test} = this.state;
                                                                        test.courseId = e.target.value;
                                                                        test.course = course.name;
                                                                        this.setState({test, activeCourse: course});
                                                                    }
                                                                }}
                                                        >
                                                            <option value="">Choose</option>
                                                            {this.props.courses.map(course => {
                                                                return <option value={course.id}>{course.name}</option>;
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label>Show Description</label>
                                                        <select className="form-control"
                                                            value={this.state.test.show_description}
                                                                onChange={(e) => {
                                                                    let {test} = this.state;
                                                                    test.show_description = e.target.value;
                                                                    this.setState({test})
                                                                }}
                                                        >
                                                            <option value="yes">Yes</option>
                                                            <option value="no">No</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-8">
                                                    <div className="form-group">
                                                        <label>Title</label>
                                                        <input type="text" className="form-control"
                                                            value={this.state.test.title || ''}
                                                               onChange={(e) => {
                                                                   let {test} = this.state;
                                                                   test.title = e.target.value;
                                                                   this.setState({test})
                                                               }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Answer Choices</label>
                                                        <select className="form-control"
                                                            value={this.state.test.answer_choices}
                                                                onChange={(e) => {
                                                                    let {test} = this.state;
                                                                    test.answer_choices = e.target.value;
                                                                    this.setState({test})
                                                                }}
                                                        >
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label>Instructions</label>
                                                        <textarea className="form-control" rows="3"
                                                        value={this.state.test.instructions}
                                                                  onChange={(e) => {
                                                                      let {test} = this.state;
                                                                      test.instructions = e.target.value;
                                                                      this.setState({test})
                                                                  }}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="nav-tabs-custom no-bg row">
                                                <ul className="questionstable nav nav-tabs">
                                                    {this.state.test.sections.map((section, index) => {
                                                        return (
                                                            <li className={this.state.activeSection == index ? "active" : ""}><a onClick={(e) => {
                                                            e.preventDefault();
                                                            this.setState({activeSection: index});
                                                        }}>{section.name || 'Section ' +  index}</a></li>
                                                        )
                                                    })}

                                                    <li><a onClick={(e) => {
                                                        e.preventDefault();
                                                        let {test} = this.state;
                                                        test.sections.push({name: '', questions: [], subjectId: ''});
                                                        this.setState({test});
                                                    }}><i className={"zmdi zmdi-plus"}></i></a></li>

                                                </ul>
                                            </div>
                                            <br />
                                            {this.state.test.sections[this.state.activeSection] &&

                                            this.state.activeCourse &&
                                            <div>

                                                {this.state.activeCourse.CourseSubject &&
                                                    <div>
                                                        <input
                                                            className="form-control"
                                                            value={this.state.test.sections[this.state.activeSection].name}
                                                           onChange={(e) => {
                                                            let {test} = this.state;
                                                            test.sections[this.state.activeSection].name = e.target.value;
                                                            this.setState({test});
                                                           }}
                                                            placeholder="Name"
                                                        />
                                                        <br />
                                                        <select disabled={true} className="form-control"
                                                                onChange={(e) => {
                                                                    let {test} = this.state;
                                                                    test.sections[this.state.activeSection].subjectId = e.target.value;
                                                                    this.setState({test});
                                                                }}
                                                                value={this.state.test.sections[this.state.activeSection].subjectId || ''}
                                                        >

                                                            <option value={""}>Subject</option>
                                                            {this.state.activeCourse.CourseSubject.map(sub => {
                                                                return <option value={sub.id}>{sub.name}</option>
                                                            })}
                                                        </select>
                                                    </div>
                                                }
                                            </div>



                                            }
                                            <br /><br />

                                                    <div className="AddNewTestQuestiosModalWrapper">
                                                <div className="duplicateablequestion">
                                                    {
                                                        this.state.test.sections &&
                                                        this.renderQuestions(this.state.test.sections)}
                                                </div>
                                            </div>
                                            <br /><br />
                                            <a
                                                href="#"
                                                className="btn btn-info"
                                                onClick={(e) => {
                                                    let {test} = this.state;

                                                    test.sections[this.state.activeSection].questions.push(JSON.parse(JSON.stringify(questionTemplate)));
                                                    this.setState({test});
                                                }}
                                                // onclick="AddMoreQuestionToTheTest(this)"
                                            >
                                                <i className="zmdi zmdi-plus-circle"/>
                                                {this.state.test.sections[this.state.activeSection] &&
                                                this.state.test.sections[this.state.activeSection].questions.length > 0 ?
                                                    "Add Another Question"
                                                : "Add a question"}

                                            </a>

                                        </div>    
        )
    }
    
    renderTestEdit = () => {
        return <EditDiagnosticTestContainer {...this.props} diagnosticTestId={this.state.diagnosticTestId} />
    }


    renderQuestions = (sections) => {

        if(this.state.activeSection >= 0 && sections[this.state.activeSection]){
            return sections[this.state.activeSection].questions.map((item, index) => (
                <div
                    key={index}
                    className="panel customPanel"
                >
                    <div className="panel-heading border-bottom bg-light">
                        <div className="panel-control">
                            <a
                                href="#"
                                className="btn btn-danger"
                                onClick={(e) => {
                                    let {test} = this.state;
                                    test.sections[this.state.activeSection].questions.splice(index, 1);
                                    this.setState({test});
                                }}
                            >
                                <i className="zmdi zmdi-delete"/>
                            </a>
                        </div>
                        <h3 className="panel-title">
                            {item.title}
                            <span className="new_test_question_number">
                            {item.number}
                        </span>
                        </h3>
                    </div>
                    <div className="panel-body bg-light-2">
                        <div className="row">

                            <div className="col-sm-7">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <label>Correct Option</label>
                                        <select
                                            className="form-control"
                                            value={this.state.test.sections[this.state.activeSection].questions[index].correctOption}
                                            onChange={(e) => {
                                                let {test} = this.state;
                                                test.sections[this.state.activeSection].questions[index].correctOption = e.target.value;
                                                this.setState({test});
                                            }}>
                                            <option value="">Select correct answer</option>
                                            <option value={"A"}>A</option>
                                            <option value={"B"}>B</option>
                                            <option value={"C"}>C</option>
                                            <option value={"D"}>D</option>
                                            {this.state.test.answer_choices == 5 &&
                                            <option value={"E"}>E</option>
                                            }

                                        </select>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="sm-top10">
                                    <br/>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Concept"
                                        value={item.concept}
                                        onChange={(e) => {
                                            let {test} = this.state;
                                            test.sections[this.state.activeSection].questions[index].concept = e.target.value;
                                            this.setState({test});
                                        }}
                                    />
                                </div>
                                <br/>
                                <div className="sm-top10">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Question"
                                        value={item.question}
                                        onChange={(e) => {
                                            let {test} = this.state;
                                            test.sections[this.state.activeSection].questions[index].question = e.target.value;
                                            this.setState({test});
                                        }}
                                    />
                                </div>
                                <br/>
                                <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    placeholder="Option A"
                                    rows="2"
                                    value={item.optionA}
                                    onChange={(e) => {
                                        let {test} = this.state;
                                        test.sections[this.state.activeSection].questions[index].optionA = e.target.value;
                                        this.setState({test});
                                    }}
                                />
                                </div>
                                <br/>
                                <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    placeholder="Option B"
                                    rows="2"
                                    value={item.optionB}
                                    onChange={(e) => {
                                        let {test} = this.state;
                                        test.sections[this.state.activeSection].questions[index].optionB = e.target.value;
                                        this.setState({test});
                                    }}
                                />
                                </div>
                                <br/>
                                <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    placeholder="Option C"
                                    rows="2"
                                    value={item.optionC}
                                    onChange={(e) => {
                                        let {test} = this.state;
                                        test.sections[this.state.activeSection].questions[index].optionC = e.target.value;
                                        this.setState({test});
                                    }}
                                />
                                </div>
                                <br/>
                                <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    placeholder="Option D"
                                    rows="2"
                                    value={item.optionD}
                                    onChange={(e) => {
                                        let {test} = this.state;
                                        test.sections[this.state.activeSection].questions[index].optionD = e.target.value;
                                        this.setState({test});
                                    }}
                                />
                                </div>

                                {this.state.test.answer_choices == 5 &&
                                <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    placeholder="Option E"
                                    rows="2"
                                    value={item.optionE}
                                    onChange={(e) => {
                                        let {test} = this.state;
                                        test.sections[this.state.activeSection].questions[index].optionE = e.target.value;
                                        this.setState({test});
                                    }}
                                />
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            ))
        }
    }

    saveTest = () => {
        if(this.state.viewMode === 'add'){
            if(this.state.activeCourse){
                if(this.state.testTemplate){
                    let test = this.state.activeCourse.ChapterTestTemplate.filter(t => t.id === this.state.testTemplate);
                    if(test.length > 0){
                        test = JSON.parse(JSON.stringify(test[0]));
                        delete test.id;
                        this.props.saveTest(test, this.props.user.id);
                        this.setState({vieWMode: 'edit', waitingForTestCreation: true});
                    }
                }
            }
           
        }else{
            this.props.saveTest(this.state.test, this.props.user.id);
            this.setState({currentTab: 0, test: testTemplate, activeSection: 0});
        }
    }

    //Lifecycle
    componentDidUpdate(props, state){
        if(this.state.waitingForTestCreation && this.props.tests !== props.tests && this.props.testId){
            this.setState({diagnosticTestId: this.props.testId, waitingForTestCreation: false, vieWMode: 'edit'});
        }    
    }
    
    renderTestName = (val, row) => {
        return (
            <span>{row.title || row.name}</span>    
        )
        
    }
    
    componentDidMount(props) {
        this.setState({
            columns: [
                {title: 'Course', prop: 'course'},
                {title: 'Subject', prop: 'subject'},
                {title: 'Title', prop: 'id', render: this.renderTestName},
                {title: 'Options', prop: 'id', render: this.renderOptions}
            ]
        });

        this.props.getDiagTemplates(this.props.user.id);
    }

    componentWillUpdate(props){
        if(this.props.course !== props.course){
            let {test} = this.state;
            test.courseId = props.course.id;
            test.course = props.course.name;
            test.sections = [];

            props.course.CourseSubject.map(sub => {
                test.sections.push({name: '', questions: [], subjectId: sub.id})
            })

            this.setState({test, activeCourse: props.course});
        }
    }
    render() {
        return (
            <div className="modal fade" id="AddStrategyModal2" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-body no-padding">
                            <div className="nav-tabs-custom ">
                                <ul className="nav nav-tabs">
                                    <li className={this.state.currentTab == 0 ? "active" : ""}>
                                        <a href="#tab_21" data-toggle="tab" onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({currentTab: 0});
                                        }}>
                                            Saved Diagnostic Tests
                                        </a>
                                    </li>
                                    <li className={this.state.currentTab == 1 ? "active" : ""}>
                                        <a href="#tab_22" id="editTestTrigger" data-toggle="tab" onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({currentTab: 1});
                                        }}>
                                            Add Diagnostic Tests
                                        </a>
                                    </li>
                                </ul>
                                <div className="tab-content bg-dark">
                                    <div className={this.state.currentTab == 0 ? "tab-pane active no-padding" : "tab-pane no-padding"} id="tab_21">
                                        {this.props.diagTestTemplates.length > 0 && this.state.columns.length > 0 ?
                                            <Table
                                                className="table table-bordered table-striped"
                                                keys="id"
                                                dataArray={this.props.diagTestTemplates}
                                                columns={this.state.columns }
                                            />
                                            : <h4>Add a test to get started</h4>}
                                    </div>
                                    <div className={this.state.currentTab == 1 ? "tab-pane active no-padding" : "tab-pane no-padding"}  id="tab_22">
                                        {
                                            this.state.viewMode === 'add' ?
                                                <div>
                                                    {this.renderTestEdit()}
                                                </div>
                                            : 
                                                <div className="onboarding-page embedded-page">
                                                    {this.renderTestEdit()}
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {this.state.currentTab === 1 &&
                                this.state.viewMode === 'add' &&
                                <div>
                                    <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                                    <button type="button" className="btn btn-primary" onClick={this.saveTest}>Create From Template</button>
                                </div>

                            }

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    ...state.auth,
    ...state.chapterPart
});

const mapDispatchToProps = dispatch => ({
    getDiagTemplates: (token) => {
        dispatch(chapterPartActions.getDiagTemplates(token));
    }
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StrategyModalDiagnosticTest);


// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/StrategyModalDiagnosticTest.js